import http from '@/http'
const URL = '/admin/pending-actions'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const review = (id, payload) => {
  return http.put(URL + `/${id}/review`, payload)
}

export const resend = (id) => {
  return http.post(URL + `/${id}/resend`)
}

export const stats = async () => {
  return http.get(URL + '/stats')
}

export const bulkReview = (payload) => {
  return http.put(URL + '/bulk-review', payload)
}

export default {
  list,
  show,
  review,
  resend,
  stats,
  bulkReview
}
